import { get } from 'lodash';
import {
	SUBMIT_ALL_TEMPLATES_SUCCESS,
	SUBMIT_CREATE_TEMPLATE_SUCCESS,
	SUBMIT_GET_TEMPLATE_SUCCESS,
	UPDATE_TEMPLATE_NAME,
	SUBMIT_CREATE_TEMPLATE_FAILURE,
	RESET_CURRENT_TEMPLATE,
	SUBMIT_UPDATE_TEMPLATE_SUCCESS,
	OVERWRITE_TEMPLATE_VERSION,
	LAST_TEMPLATE_SAVE_TYPE,
	SUBMIT_UPDATE_TEMPLATE_FAILURE,
	initialState,
} from './actions';
import { TOGGLE_TEMPLATE_MODE } from './toggleTemplateMode';
import { updateTemplateResponse } from '../../config';
import { RESET_APP } from '../page/actions';

const templates = (state = initialState, action) => {
	switch (action.type) {
		case SUBMIT_ALL_TEMPLATES_SUCCESS: {
			return { ...state, list: action.payload.templates };
		}
		case SUBMIT_CREATE_TEMPLATE_SUCCESS: {
			return {
				...state,
				list: [...state.list, action.payload.template],
				currentTemplate: {
					...state.currentTemplate,
					id: action.payload.template.id,
					version: action.payload.template.version,
				},
			};
		}
		case SUBMIT_CREATE_TEMPLATE_FAILURE: {
			const { status } = action.payload;
			const { type = '' } = action.payload.response;
			if (status === 409 && type === updateTemplateResponse.duplicateName) {
				return { ...state, currentTemplate: { ...state.currentTemplate, duplicateName: true } };
			}

			return state;
		}

		case SUBMIT_GET_TEMPLATE_SUCCESS: {
			const fetchedTemplate = action.payload.template;

			return {
				...state,
				currentTemplate: {
					name: fetchedTemplate.name,
					id: fetchedTemplate.id,
					duplicateName: false,
					version: fetchedTemplate.version,
				},
			};
		}
		case SUBMIT_UPDATE_TEMPLATE_SUCCESS:
			return {
				...state,
				currentTemplate: {
					...state.currentTemplate,
					version: get(action, 'payload.template.version'),
					versionConflict: false,
				},
			};
		case UPDATE_TEMPLATE_NAME:
			return { ...state, currentTemplate: { ...state.currentTemplate, name: action.name, duplicateName: false } };
		case RESET_CURRENT_TEMPLATE: {
			return {
				...state,
				currentTemplate: {
					name: action.name,
					id: '',
					version: '',
					duplicateName: false,
					versionConflict: false,
					newVersion: '',
					updatedBy: '',
					lastUpdatedTime: '',
				},
			};
		}

		case RESET_APP:
			return initialState;
		case OVERWRITE_TEMPLATE_VERSION:
			return { ...state, currentTemplate: { ...state.currentTemplate, version: state.currentTemplate.newVersion } };
		case LAST_TEMPLATE_SAVE_TYPE:
			return { ...state, lastSaveType: action.lastSaveType };
		case SUBMIT_UPDATE_TEMPLATE_FAILURE: {
			const { status } = action.payload;
			const { type = '', user = '', version = '', last_updated_timestamp = '' } = action.payload.response;

			if (status === 409 && type === updateTemplateResponse.duplicateName) {
				return { ...state, currentTemplate: { ...state.currentTemplate, duplicateName: true } };
			}

			if (status === 409 && type === updateTemplateResponse.newVersion) {
				return {
					...state,
					currentTemplate: {
						...state.currentTemplate,
						newVersion: version,
						lastUpdatedBy: user,
						versionConflict: true,
						lastUpdatedTime: last_updated_timestamp,
					},
				};
			}

			return state;
		}
		case TOGGLE_TEMPLATE_MODE:
			return { ...state, templateMode: action.value };
		default:
			return state;
	}
};

export default templates;
